<template>
    <!--实现逻辑内容 -->
  <div class="question_list">
    <div class="question_item" v-for="item in Datalist">
      <a @click="changeHash(item.href)">  <!--v-bind="{href:item.href}" -->
        {{item.des}}
      <img src="../assets/list_ic_more.png" />
      <div class="seperate_line"></div>
      </a>
    </div>
  </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {}
        },
        methods: {
          ScrollTo:function(ref){
            this.$emit('scrollto',ref);
          }
        },
      props:{
          Datalist:{
            type:Array,
            default:function(){
              return [
                {des:'·空调安装说明',ref:''},
                {des:'·空调"三包期限"？',ref:''},
                {des:'·不属于"三包"范围的说明',ref:''},
              ]
            }
          },
          scroll:{
            type: Object,
            default:function(){
              return {}
            }
          }
      },
      methods:{
        changeHash(idName) {
          let element = document.querySelector(idName);
          this.scroll.scrollToElement(element);
        }
      },
      mounted(){

      }
    }
</script>

<style scoped>
 table,
 td {
   border: 1px solid black;
 }

 table {
   border-collapse: collapse;
 }

 td {
   text-align: center;
   padding: 5px;
 }
.question_list{
  margin-top: 10px;
  width:100%;
}
  .question_item{
    width:100%;
    height:49px;
    margin-top: 1px;
    background: white;
    font-size: 14px;
    color: #28B9F5;
    letter-spacing: 0;
    display: inline-block;
    line-height: 49px;
    text-align: left;
    padding-left: 16px;
  }
  .question_item>a>img{
    width:8px;
    height:12px;
    float:right;
    margin-top: 25px;
    transform: translateY(-50%);
    margin-right: 46px;
  }
  .seperate_line{
    width:92%;
    /*margin-left: 10%;*/
    height:1px;
    background:  #F0F1F4;
  }
  a:active,a:hover,a:link,a:visited{
    text-decoration: none;
    color: #28B9F5;
  }
</style>



// WEBPACK FOOTER //
// src/components/questionList.vue